@if (germanAMLChangesEnabled && instrumentFormGroup.controls.productPreferenceFormGroup) {
    <app-product-preference [productPreferenceFormGroup]="instrumentFormGroup.controls.productPreferenceFormGroup" />
}
<div class="instrumentList">
    <form [formGroup]="instrumentFormGroup" class="form-control-wrapper options-list-dropdown mt-10">
        @if (!userData?.configParams?.pixBrInfo?.isNewBrLabel) {
            <mat-label class="pm-select-label text-bold">{{ 'PARTY.CASHIER.web.deposit.select.pm' | translate }}</mat-label>
        }
        <mat-form-field class="payment-method-options" [class.nolabel]="userData?.configParams?.pixBrInfo?.isNewBrLabel">
            <mat-select
                class="payment-option"
                formControlName="instrumentFormCtrl"
                id="instrumentFormCtrl"
                (selectionChange)="onChange($event)"
                disableOptionCentering>
                <mat-select-trigger>
                    <option-content
                        class="d-flex"
                        [usedOption]="selectedPaymentMethod"
                        [isUSLabel]="isUSLabel"
                        [class.disabled]="selectedPaymentMethod?.ESIntensiveGreyOut || selectedPaymentMethod?.isESRiskPlayer"></option-content>
                    @if (selectedPaymentMethod?.ESIntensiveGreyOut) {
                        <div class="drop-down-option-position position-absolute d-flex align-items-center">
                            <span class="txt-sm-v2 mr-1">{{ 'PARTY.CASHIER.web.deposit.intensive.player.message' | translate }}</span>
                            <span
                                class="theme-info-i"
                                (click)="$event.stopPropagation(); isIntensivePlayer()"
                                (mouseenter)="$event.stopPropagation(); isIntensivePlayer()"
                                [popper]="tooltipcontent2"
                                [popperPositionFixed]="true"
                                [popperTrigger]="isMobile ? NgxPopperjsTriggers.click : NgxPopperjsTriggers.hover"
                                [popperPlacement]="NgxPopperjsPlacements.BOTTOM"></span>
                        </div>
                    }
                    <popper-content class="tooltip-info ngxp__tooltip" #tooltipcontent2>
                        <div class="intensive-player-message th-scroll">
                            <strong class="h6-v2">{{ 'PARTY.CASHIER.web.deposit.intensive.player.message1' | translate }}</strong>
                            <p class="tooltip-description" [vnDynamicHtml]="'PARTY.CASHIER.web.deposit.intensive.player.message2' | translate"></p>
                            <a (click)="moreInfoLink()" class="popper-buttons tooltip-description">
                                <span class="popper-close-link dh">{{ 'PARTY.CASHIER.web.deposit.intensive.player.message3' | translate }}</span>
                            </a>
                        </div>
                    </popper-content>
                </mat-select-trigger>
                @for (usedOption of usedOptions; track usedOption; let i = $index) {
                    <mat-option
                        [disabled]="
                            (maxFailDepEnhancementEnabled && usedOption?.userMaxFailDepStatus?.blocked) ||
                            usedOption?.ESIntensiveGreyOut ||
                            usedOption?.isESRiskPlayer
                        "
                        class="p-0 payment-option-list"
                        [value]="usedOption">
                        <option-content
                            [class.disabled]="
                                (maxFailDepEnhancementEnabled && usedOption?.userMaxFailDepStatus?.blocked) ||
                                usedOption?.ESIntensiveGreyOut ||
                                usedOption?.isESRiskPlayer
                            "
                            class="d-flex"
                            [usedOption]="usedOption"
                            [isUSLabel]="isUSLabel"></option-content>
                        @if (maxFailDepEnhancementEnabled && usedOption?.userMaxFailDepStatus?.blocked) {
                            <div class="mfde-alignment position-absolute d-flex align-items-center">
                                <span class="txt-sm-v2 mr-1">{{ 'PARTY.CASHIER.web.deposit.mfde.paused' | translate }}</span>
                                <span
                                    class="theme-info-i"
                                    (click)="$event.stopPropagation()"
                                    [popper]="tooltipcontent"
                                    [popperPositionFixed]="true"
                                    [popperTrigger]="isMobile ? NgxPopperjsTriggers.click : NgxPopperjsTriggers.hover"
                                    [popperPlacement]="NgxPopperjsPlacements.BOTTOM"></span>
                            </div>
                        }
                        @if (usedOption?.ESIntensiveGreyOut) {
                            <div class="drop-down-option-position position-absolute d-flex align-items-center">
                                <span class="txt-sm-v2 mr-1">{{ 'PARTY.CASHIER.web.deposit.intensive.player.message' | translate }}</span>
                                <span
                                    class="theme-info-i"
                                    (click)="$event.stopPropagation(); isIntensivePlayer()"
                                    (mouseenter)="$event.stopPropagation(); isIntensivePlayer()"
                                    [popper]="tooltipcontent1"
                                    [popperPositionFixed]="true"
                                    [popperTrigger]="isMobile ? NgxPopperjsTriggers.click : NgxPopperjsTriggers.hover"
                                    [popperPlacement]="NgxPopperjsPlacements.BOTTOM"></span>
                            </div>
                        }
                    </mat-option>
                    <popper-content class="tooltip-info ngxp__tooltip" id="tooltipcontent{{ i }}" #tooltipcontent>
                        <div class="curfew-blue">
                            <strong class="h6-v2">{{ 'PARTY.CASHIER.web.deposit.mfde.payment.method.hold.header' | translate }}</strong>
                            <p class="tooltip-description">
                                <span class="txt-sm-v2"
                                    >{{
                                        'PARTY.CASHIER.web.deposit.mfde.payment.method.hold.tooltip'
                                            | translate
                                                : {
                                                      time: usedOption?.userMaxFailDepStatus?.blockEndTime,
                                                      date: usedOption?.userMaxFailDepStatus?.blockEndDate,
                                                  }
                                    }}
                                </span>
                            </p>
                        </div>
                    </popper-content>
                    <popper-content class="tooltip-info ngxp__tooltip" id="tooltipcontent{{ i }}" #tooltipcontent1>
                        <div class="intensive-player-message th-scroll">
                            <strong class="h6-v2">{{ 'PARTY.CASHIER.web.deposit.intensive.player.message1' | translate }}</strong>
                            <p class="tooltip-description" [vnDynamicHtml]="'PARTY.CASHIER.web.deposit.intensive.player.message2' | translate"></p>
                            <a (click)="moreInfoLink()" class="popper-buttons tooltip-description">
                                <span class="popper-close-link dh">{{ 'PARTY.CASHIER.web.deposit.intensive.player.message3' | translate }}</span>
                            </a>
                        </div>
                    </popper-content>
                }
                <mat-option [value]="'allDepositOptions'" class="p-0">
                    <div class="d-flex align-items-center">
                        <div class="payment-method-logo payment-method-moreoptions"></div>
                        <p class="all-payment-option">{{ 'PARTY.CASHIER.web.deposit.more.options' | translate }}</p>
                    </div>
                </mat-option>
            </mat-select>
        </mat-form-field>
        <!-- Bank Account Registration PIX flow -->
        @if (showBrazilBankList || (selectedPaymentMethod?.paymentMethod?.toUpperCase() == 'PIX' && this.pixBankRegistration.isEnabled)) {
            <div class="pix-bank-account-wrapper">
                <mat-label class="pm-select-label text-bold d-inline-block">
                    {{
                        (showBrazilBankList
                            ? 'PARTY.CASHIER.web.deposit.ftd.source.bank.account.label'
                            : 'PARTY.CASHIER.web.deposit.pix.bankaccount.label'
                        ) | translate
                    }}
                    <img
                        [src]="assetsData.assets.brazilimages?.pixInfo"
                        class="cursor-pointer ml-2"
                        [popper]="tooltipcontent"
                        [popperPositionFixed]="true"
                        [popperTrigger]="NgxPopperjsTriggers.click"
                        [popperPlacement]="NgxPopperjsPlacements.BOTTOM"
                        [popperApplyClass]="'popperSpecialStyle'" />
                </mat-label>
                <popper-content class="tooltip-info ngxp__tooltip" #tooltipcontent>
                    <div class="tooltip-description">
                        {{ 'PARTY.CASHIER.web.deposit.pix.bankaccount.tooltip' | translate }}
                    </div>
                </popper-content>
                <mat-form-field [ngClass]="{ 'brazil-bank-list-form-field': showBrazilBankList }">
                    @if (showBrazilBankList) {
                        <mat-label>{{ 'PARTY.CASHIER.web.deposit.ftd.select.account.label' | translate }}</mat-label>
                    }
                    <mat-select
                        formControlName="pixAccountSelect"
                        name="pixAccountSelect"
                        panelClass="pix-bank-account-select"
                        (selectionChange)="onPixAccountChange($event)"
                        (opened)="onDropdownOpened()">
                        <mat-select-trigger class="pix-select-trigger">
                            {{ pixBankRegistration.selectedInfo?.bankName }}
                        </mat-select-trigger>
                        @for (bank of selectedPaymentMethod?.BANK_INSTRUMENT_LIST; track bank) {
                            <mat-option [value]="bank?.bankName + '-' + bank?.accountNumber">
                                <div class="bank-option d-flex flex-column">
                                    <div class="bank-name">{{ bank?.bankName }}</div>
                                    <div class="bank-details">
                                        {{
                                            (showBrazilBankList
                                                ? 'PARTY.CASHIER.web.deposit.ftd.branchcode.label'
                                                : 'PARTY.CASHIER.web.deposit.pix.branchcode'
                                            ) | translate
                                        }}
                                        {{ bank?.branchCode }} &nbsp;&nbsp;|&nbsp;&nbsp; {{ 'PARTY.CASHIER.web.deposit.pix.account' | translate }}
                                        {{ bank?.accountNumber | accountFormat }}
                                    </div>
                                </div>
                            </mat-option>
                        }
                        <div
                            (click)="onAccountLinkClick()"
                            class="pix-account-actions d-flex align-items-center justify-content-between py-2 px-3 cursor-pointer"
                            [ngClass]="{ 'border-0': selectedPaymentMethod?.BANK_INSTRUMENT_LIST?.length == 1 }">
                            <a href="javascript:void(0)" class="text-decoration-none">
                                {{
                                    (showBrazilBankList
                                        ? 'PARTY.CASHIER.web.deposit.ftd.deposit.from.another.account.link'
                                        : selectedPaymentMethod &&
                                            selectedPaymentMethod.BANK_INSTRUMENT_LIST &&
                                            userData &&
                                            userData.configParams &&
                                            selectedPaymentMethod.BANK_INSTRUMENT_LIST.length >= userData.configParams.bank_registration_allowed_count
                                          ? 'PARTY.CASHIER.web.deposit.pix.manageAccounts'
                                          : 'PARTY.CASHIER.web.deposit.pix.newAccount'
                                    ) | translate
                                }}
                            </a>
                            <span class="ui-icon ui-icon-size-sm float-right ui-close theme-right"></span>
                        </div>
                    </mat-select>
                </mat-form-field>
                @if (showBrazilBankList) {
                    <span class="fs-12 txt-color-80">{{ 'PARTY.CASHIER.web.deposit.ftd.source.bank.match.required' | translate }}</span>
                }
            </div>
        }

        @if (ccDepositLimitCheckEnabled && optionListService.selectedOption.creditCard) {
            <show-message id="creditcard_deposit_limit_message2" [type]="messageType.INFO">
                <p
                    info
                    [vnDynamicHtml]="
                        'PARTY.CASHIER.web.deposit.ny.creditcard.deposit.limit.annual.message'
                            | translate
                                : {
                                      annualLimit: +ccCurrentDepositLimit | vnCurrency: currencyUSD,
                                  }
                    "></p>
            </show-message>
        }

        @if (isInstantEchecks) {
            <div>
                <input
                    type="hidden"
                    name="vipPreferredAccountNumber"
                    [(ngModel)]="depositService.depositInfo.paymentAccountInfo.vipPreferredAccountNumber" />
                <b>
                    <span>
                        {{
                            'PARTY.CASHIER.web.deposit.instantechecks.accountbalance.msg'
                                | translate
                                    : {
                                          accountbalanceInfo:
                                              optionListService?.selectedOption?.accountBalance
                                              | vnCurrency
                                                  : optionListService?.selectedOption?.paymentMethodInfo?.minDepositLimit?.currencyCode?.toUpperCase()
                                                  : '1.2-2',
                                      }
                        }}
                    </span>
                </b>
            </div>
        }

        @if (prepaidCards.includes(inputType.toUpperCase())) {
            <div class="text-bold">
                {{
                    'PARTY.CASHIER.web.deposit.prepaidcard.accountbalance.msg'
                        | translate
                            : {
                                  accountbalanceInfo:
                                      optionListService?.selectedOption?.accountBalance
                                      | vnCurrency
                                          : optionListService?.selectedOption?.paymentMethodInfo?.minDepositLimit?.currencyCode?.toUpperCase()
                                          : '1.2-2',
                              }
                }}
            </div>
        }

        @if (loaderService.depositRedirectInProgress()) {
            <app-redirect-message />
        }
    </form>

    <div
        class="clear-both"
        [ngClass]="ccFamily.includes(inputType.toUpperCase()) ? 'space-between-width-50' : 'non-cc-amt-field'"
        [class.disabled]="!!(selectedPaymentMethod?.ESIntensiveGreyOut || selectedPaymentMethod?.isESRiskPlayer)">
        @if (optionListService.selectedOption && optionListService.selectedOption.paymentMethodInfo?.paymentMethod != 'FLASH1VOUCHER') {
            <app-amount [amountFormGroup]="amountFieldFormGroup" [selectedOption]="optionListService.selectedOption" />
        }

        @if (instrumentFormGroup.controls.instrumentInputFormGroup) {
            @if (ccFamily.includes(inputType.toUpperCase())) {
                <div class="cc-input">
                    <app-cc-input [ccInputFormGroup]="instrumentFormGroup.controls.instrumentInputFormGroup" />
                </div>
            }

            @if (inputType === 'FLASH1VOUCHER') {
                <div class="non-cc-amt-field">
                    <app-flash1-voucher-input [voucherInputFormGroup]="instrumentFormGroup.controls.instrumentInputFormGroup" />
                </div>
            }
        }
    </div>
    @if (depositInfo.isBelgiumRgDecreeEnabled && amountFieldFormGroup?.controls?.userAmount?.status === 'VALID' && rgLimitData) {
        <threshold-limit-messages />
    }
    @if (showPreemptiveMsg && amountFieldFormGroup?.controls?.userAmount?.status === 'VALID') {
        <show-message [type]="messageType.WARNING">
            <div warning>
                <p class="text-bold">
                    {{
                        'PARTY.CASHIER.web.deposit.aml.preemptive.header'
                            | translate
                                : {
                                      remainingLimit: es_allowed_amount | vnCurrency,
                                  }
                    }}
                </p>
                <p
                    [innerHtml]="
                        'PARTY.CASHIER.web.deposit.aml.msg1' | translate: { paymentName: selectedPaymentMethod?.paymentMethod?.toUpperCase() }
                    "></p>
                <div class="float-right mt-2">
                    <a class="text-bold text-decoration-none cursor-pointer text-uppercase" (click)="verifyAccount(selectedPaymentMethod)">
                        {{ 'PARTY.CASHIER.web.deposit.aml.verify.txt' | translate }}
                    </a>
                </div>
            </div>
        </show-message>
    }
    @if (
        ((amountFieldFormGroup?.controls?.userAmount?.dirty || amountFieldFormGroup?.controls?.userAmount?.touched) &&
            optionListService?.selectedOption &&
            amountFieldFormGroup?.controls?.userAmount?.hasError('selfSetLimit')) ||
        enablePrepaidcardRestrictions ||
        amountFieldFormGroup?.controls?.userAmount?.hasError('spainRekycLimit') ||
        amountFieldFormGroup?.controls?.userAmount?.hasError('spainOdInlineVal') ||
        amountFieldFormGroup?.controls?.userAmount?.hasError('spainThreshLimitToBeBreached') ||
        amountFieldFormGroup?.controls?.userAmount?.hasError('spainThreshLimitBreached') ||
        amountFieldFormGroup?.controls?.userAmount?.hasError('spainAnnRekycLimitExceeded') ||
        amountFieldFormGroup?.controls?.userAmount?.hasError('expiredKycLimitValidation')
    ) {
        <app-deposit-limit-message [selectedOption]="optionListService.selectedOption" [amountFormGroup]="amountFieldFormGroup" />
    }

    @if (inputType === 'GAMERSCARD') {
        <app-password-block />
    }

    @if (!defaultCurrency) {
        <app-transaction-currency [defaultCurrency]="depositInfo.amountInfo.nativeCurrency" />
    }
</div>
@if (userData?.configParams?.colombia_deposit_tax_enabled == 'Y' && amountFieldFormGroup?.controls?.userAmount?.value) {
    @let currencyCode = optionListService?.selectedOption?.paymentMethodInfo?.minDepositLimit?.currencyCode ?? '';
    <div class="mt-1 mb-2 vat-tax-info-details">
        <p class="m-0">
            <span class="fs-12">{{ 'PARTY.CASHIER.web.deposit.vatTaxInfo.totalDeposit' | translate }}</span>
            <span class="float-right fs-12 text-bold"
                >{{ amountFieldFormGroup?.controls?.userAmount?.value }} {{ currencyCode | vnCurrencySymbol }}</span
            >
        </p>
        <p class="m-0">
            <span class="fs-12">{{ 'PARTY.CASHIER.web.deposit.vatTaxInfo.vatDeduction' | translate }}</span>
            <span class="float-right fs-12 text-bold">- {{ depositService.vatDeductionAmount() }} {{ currencyCode | vnCurrencySymbol }}</span>
        </p>
        <p class="m-0">
            <span class="fs-12">{{ 'PARTY.CASHIER.web.deposit.vatTaxInfo.bonus' | translate }}</span>
            <span class="float-right fs-12 text-bold success-txt"
                >{{ depositService.vatDeductionAmount() }} {{ currencyCode | vnCurrencySymbol }}</span
            >
        </p>
        <p class="m-0">
            <span class="fs-12">{{ 'PARTY.CASHIER.web.deposit.vatTaxInfo.netDeposit' | translate }}</span>
            <span class="float-right fs-12 text-bold"
                >{{ amountFieldFormGroup?.controls?.userAmount?.value }} {{ currencyCode | vnCurrencySymbol }}</span
            >
        </p>
    </div>
}
@if (showBrazilConsent && consentFormControl) {
    <div class="consentCheckBox">
        <!-- Checkbox for consent -->
        <div class="form-element">
            <input
                type="checkbox"
                id="consentCheck"
                [formControl]="consentFormControl"
                class="custom-control-input custom-control-checkbox"
                (change)="onConsentChange($event)" />
            <label for="consentCheck" class="d-flex align-items-center">
                <span class="txt-color-100">
                    {{ 'PARTY.CASHIER.web.deposit.consent.brazil.ftd.txt' | translate }}
                </span>
            </label>
        </div>
    </div>
}
